/** @format */

export default class Utils {
  /**
   * 对象转变成option[]
   * @param obj
   * @param Fun
   */
  static toLabelVal<T extends object, K extends keyof T>(obj: T, Fun?: (key: string) => any) {
    return Object.keys(obj).map(key => {
      return {
        label: obj[key as K],
        value: Fun ? Fun(key) : key
      };
    });
  }

  static toNameVal<T extends object, K extends keyof T>(obj: T, Fun?: (key: string) => any) {
    console.log(Object.keys(obj));
    return Object.keys(obj).map(key => {
      return {
        name: obj[key as K],
        value: Fun ? Fun(key) : key
      };
    });
  }

  static toNumberOption({
    max,
    min,
    tap,
    subfix
  }: {
    max: number;
    min: number;
    tap: number;
    subfix?: string;
  }): Array<{ label: string; value: number }> {
    let i = min;
    const result: Array<{ label: string; value: number }> = [];
    while (i <= max) {
      result.push({
        label: i.toString() + (subfix || ''),
        value: i
      });
      i += tap;
    }

    return result;
  }

  /**
   * 对象转换成Map
   * @param obj
   * @constructor
   */
  static ObjectToMap(obj: Indexable<string>): Map<string, string> {
    return new Map(Object.entries(obj));
  }

  /**
   * 对象转换成Map反转
   * @param obj
   * @constructor
   */
  static ObjectToMapReverse(obj: Indexable<string>): Map<string, string> {
    // @ts-ignore
    return new Map(
      Object.entries(obj).map(item => {
        const [key, value] = item;
        return [value, key];
      })
    );
  }

  //时间格式化
  static getFormatTime(date: any, fmt: string) {
    if (date) {
      if (date instanceof Date) {
        const o = {
          'Y+': date.getFullYear(),
          'M+': date.getMonth() + 1, // 月份
          'D+': date.getDate(), // 日
          'H+': date.getHours(), // 小时
          'm+': date.getMinutes(), // 分
          's+': date.getSeconds() // 秒
        };
        if (/(y+)/.test(fmt)) {
          fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
          for (const k of Object.keys(o)) {
            if (new RegExp('(' + k + ')').test(fmt)) {
              fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
            }
          }
        }
        return fmt;
      } else {
        return date;
      }
    } else {
      return null;
    }
  }

  static compare(prop) {
    return function(obj1, obj2) {
      var val1 = obj1[prop];
      var val2 = obj2[prop];
      if (val1 < val2) {
        return -1;
      } else if (val1 > val2) {
        return 1;
      } else {
        return 0;
      }
    };
  }
}
